import React from "react";
import {observer} from "mobx-react-lite";
import appStore from "../../storage/AppStore";
import {Menubar} from "primereact/menubar";
import {useNavigate} from "react-router-dom";

const AdminMenu = () => {
    const navigate = useNavigate()
    if (!appStore.user.is_admin) return null
    const items = [
        {label: 'Home', icon: 'pi pi-home', command: () => {navigate('/')}},
        {label: 'Companies', icon: 'pi pi-building', command: () => {navigate('/companies')}}
    ]
    return (
        <div className="card">
            <Menubar model={items} />
        </div>
    )
}
export default observer(AdminMenu)